import { render, staticRenderFns } from "./PlaceInformation.vue?vue&type=template&id=c9623726&scoped=true"
import script from "./PlaceInformation.vue?vue&type=script&lang=js"
export * from "./PlaceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9623726",
  null
  
)

export default component.exports